import { getChainId } from 'src/libs/rainbow';
import { Address } from 'viem';
import { useChainId } from 'wagmi';

const MAP_VAULT_ADDRESS = {
  [getChainId('bitLayer')]: process.env.REACT_APP_BITLAYER_VAULT_CONTRACT_ADDRESS,
  [getChainId('ethereum')]: process.env.REACT_APP_ETHEREUM_VAULT_CONTRACT_ADDRESS,
  [getChainId('nibiru')]: process.env.REACT_APP_NIBIRU_VAULT_CONTRACT_ADDRESS,
  [getChainId('arbitrum')]: process.env.REACT_APP_ARB_VAULT_CONTRACT_ADDRESS,
  [getChainId('binance')]: process.env.REACT_APP_BSC_VAULT_CONTRACT_ADDRESS,
  // [chains.sei.id]: process.env.REACT_APP_SEI_VAULT_CONTRACT_ADDRESS,
  [getChainId('avalanche')]: process.env.REACT_APP_AVALANCHE_VAULT_CONTRACT_ADDRESS,
} satisfies Record<number, Address>;

export const useVaultAddress = () => {
  let chainId = useChainId();

  const address = MAP_VAULT_ADDRESS[chainId];

  if (!address) {
    // throw new Error(`Unsupported network ${chainId}`);
    return '' as Address;
  }

  return address;
};
